import React, { useState, useEffect } from "react";
import { useSelector, useDispatch,connect } from "react-redux";
import { useLocation,useHistory } from "react-router";
import { RiWhatsappFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import {
  getCity,
  setCity,
  getCall,
  otpLogin,
  otpVerification,
} from "../../../Redux/Actions";
import { FALSE } from "node-sass";
import { set } from "js-cookie";
import PatientActions from "../../../components/Cart/PatientDetailsAction"

const NewPhoneModel = (props) => {
  const { position, title, isLp, reset, push } = props
  console.log("props", reset);
  // const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  // const [userCity, setUserCity] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [success, setSuccess] = useState(false);
  const [checkboxState, setCheckboxState] = useState(true);
  const [bookingConfirmed, setHideSuccess] = useState(false);
  const otpverification = useSelector((state) => state.otpverification);
  const { loading, otpVerificationResponse, error } = otpverification;
  // const [displayCityList, setDisplay] = useState(true);

  const [firstForm, setFirstForm] = useState(true);
  const [BookingSuccess, setBookingSuccess] = useState(false);

  const [resetpage, setresetpage] = useState(false);

  // console.log(props.userProfile.phonenumber, "in modele <<<<")
  //calling city name api

  useEffect(() => {
    dispatch(getCity());
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props?.getProfileDetails(token)
    }
  }, []);


  useEffect(() => {
    if (props?.userProfile?.username) {
      setUserNumber(props?.userProfile?.phonenumber);
    }
  }, [props?.userProfile]);  

  //ALL OTP VERIFY CODE STARTS HERE
  const otpResponse = useSelector((state) => state.otpLogin);
  const existingCustomer_data = useSelector(
    (state) => state.getCustomerDashboard
  );
  const { loading: loadingotp } = otpResponse;
  // console.log("getting otp Response data", otpResponse);

  const OtpLoginResponse = otpResponse.otploginResponse;
  //this code after otp validates

  //inserting userData to localStorage
  //inserting userData to localStorage
  useEffect(() => {
    if (error) {
      console.log("invalid user");
      setOtpError(error);
    } else if (otpVerificationResponse && otpVerificationResponse.user) {
      setBookingSuccess(true);

      // history.push("/customerdashboard")
      // window.location.replace("/customerdashboard");
    }
  }, [loading]);

  useEffect(() => {
    setFirstForm(true);
    setBookingSuccess(false);
    otpClear();
  }, [reset]);
  //comment
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  // const cityList = useSelector((state) => state.cityList);
  // const { cities, loading } = cityList;

  const dispatch = useDispatch();

  const location = useLocation();
  ///${position}

  var url = `https://redcliffelabs.com${location.pathname}`;

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number");
      return false;
    } else {
      return true;
    }
  };

  const handleCheckChange = (e) => {
    setCheckboxState(!checkboxState);
  };

  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    let phoneno = /^\d{10}$/;

    if (!e.target.value.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number");
    } else {
      setPhoneEror("");
    }

    setUserNumber(e.target.value);
  };

  useEffect(() => {
    if (userNumber == "") {
      setPhoneEror("");
    }
  }, [userNumber]);

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();
    const otpModel = { phone_number: userNumber };
    if (checkVal) {
      const body = {
        optin: checkboxState,
        name: "",
        phone_no: userNumber,
        source: "Ecommerce",
        city: "",
        url,
      };
      console.log(body);
      setUserNumber("");
      dispatch(getCall(body));
      isLp ? setFirstForm(false) : null
      

     isLp ? dispatch(otpLogin(otpModel)) : null;
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    }
  };

  //
  const [otpverify, setOtpVerify] = useState("");
  const [otpError, setOtpError] = useState("");
  const [phoneForm, setPhoneForm] = useState(true);
  // const [error, setoTPeRROR] = useState(false);

  const history = useHistory();
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  var [otp1, setotp1] = useState(new Array(6).fill(""));

  // var fulldata = otp1.map((data)=>(data))
  // console.log(fulldata.join(""));

  const handleChange1 = (element, index) => {
    if (isNaN(element.value)) return false;
    setotp1([...otp1.map((d, idx) => (idx === index ? element.value : d))]);

    var input = document.getElementById(`id${index}`);

    input.onkeydown = function() {
      var key = element.keyCode || element.charCode;

      if (key == 8 || key == 46) {
        input.previousSibling.f;
      }
    };

    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };

  const otpClear = () => {
    setotp1([...otp1.map((d) => "")]);
  };

  const handleOtpSubmit = (e) => {
    //getting data from store
    e.preventDefault();
    const data123 = otp1.join("");
    console.log("otp login response", otpverification);
    //getting code ends here
    const otpverifyModel = {
      user: {
        email: `${OtpLoginResponse.phone_number}`,
        password: `${data123}`,
      },
    };
    setOtpVerify("");
    setTimeout(() => {
      setOtpError("");
    }, 2000);
    if (push) {
      history.push({
        search: "?/ThankYou",
      });
    }
    dispatch(otpVerification(otpverifyModel));
  };

  return (
    <div>
      {firstForm ? (
        <form onSubmit={handelSubmit}>
          <div className="form__div">
            {/* <h4>Book Your Test</h4> */}

            {isLp ? (
              <h4 style={{ fontSize: "2rem" , color:"#093462" }}>Book Test Via OTP</h4>
            ) : (
              <h4 style={{color:"#093462"}}>{title ? title : "get a free call"}</h4>
            )}

            {/* <div className="phone_number">
                    +91 */}
            <div>
              <div
                style={isLp ? { height: "48px" } : null}
                className="form__input numBox"
              >
                <span className="numIcon">+91</span>
                <div className="inputDiv">
                  <input
                    type="text"
                    placeholder="Enter Phone Number"
                    required
                    style={{border:"none"}}
                    onChange={handelPhoneChange}
                    value={userNumber}
                  />
                </div>
              </div>
              <span className="FormError">{phoneError}</span>

              {isLp ? null : (
                <div className="opt_Div">
                  <input
                    type="checkbox"
                    onChange={() => handleCheckChange()}
                    defaultChecked
                    style={{ width: "22px", height: "22px" }}
                  />
                  <span className="watsap">
                    <RiWhatsappFill
                      style={{ fontSize: "2.5rem", color: "#2bcc57" }}
                    />
                  </span>
                  <span className="textt">Opt-in for WhatsApp updates </span>
                </div>
              )}
            </div>

            {/* </div>   */}
            <span className="success">
              {" "}
              {success
                ? "Your data  has been submitted successfully!"
                : null}{" "}
            </span>
            <button
              style={isLp ? { fontSize: "2rem", height: "48px" } : null}
              type="submit"
              disabled={phoneError ? "disabled" : ""}
              className={phoneError ? "disabled" : ""}
            >
              {isLp ? "Request OTP" : "Submit"}
            </button>
          </div>
        </form>
      ) : null}

      {/** VERIFYING OTP */}
      {isLp ? (
        <form
          onSubmit={handleOtpSubmit}
          autoComplete="off"
          className={
            !firstForm && !BookingSuccess
              ? "modal-form login-form show"
              : " hide"
          }
          style={isLp ? { padding: "2px" } : null}
        >
          {isLp ? (
            <h4
              style={
                isLp
                  ? {
                      fontSize: "2rem",
                      fontFamily: "Jost",
                      color: "#0e3f6c",
                      margin: "5px 0",
                    }
                  : null
              }
            >
              Enter OTP
            </h4>
          ) : (
            <h2>Verify OTP</h2>
          )}

          <p className="Loginpara1">Please enter 6-digit OTP</p>
          <p className="Loginpara2"> OTP</p>
          <div className={error ? "BorDer_red otpFieldDiv" : "otpFieldDiv"}>
            {otp1.map((data, index) => (
              <input
                className="otpField"
                placeholder="-"
                type="text"
                name="otp"
                id={`id${index}`}
                required
                maxLength="1"
                key={index}
                value={data}
                onChange={(e) => handleChange1(e.target, index)}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>
          {otpError == "" ? null : <span className="otpError">{otpError}</span>}
          {BookingSuccess ? (
            <span className="success"> Booking Confirmed</span>
          ) : null}
          <button type="submit" className="Login_submit">
            <span className="btn"> {isLp ? "Submit" : "Verify OTP"} </span>
          </button>
        </form>
      ) : null}

      {BookingSuccess ? (
        <span className="success" style={{ fontSize: "3rem", width: "100%" }}>
          {" "}
          Booking Confirmed
        </span>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(NewPhoneModel))

